import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import { ModalProvider } from './Components/Modal/ModalContext';
import { TimeModalProvider } from './Components/TimeModal/TimeModalContext';

import Index from './Pages/Index';
import Home from './Pages/Home';
import Applications from './Pages/Applications';
import Favorites from './Pages/Favorites';
import Appointments from './Pages/Appointments';
import Complaints from './Pages/Complaints';
import OtherCases from './Pages/OtherCases';
import PageOfCase from './Pages/PageOfCase';
import ViewFeedback from './Pages/ViewFeedback';
import TypesCategoriesPhases from './Pages/TypesCategoriesPhases';
import UserAccess from './Pages/UserAccess';
import DeactivatedAccounts from './Pages/DeactivatedAccounts';
import EmailsAM from './Pages/EmailsAM';
import Inbox from './Pages/Inbox';
import Testing from './Pages/Testing';
import ChangePassword from './Pages/ChangePassword';
import Login from './Pages/Login';
import Logout from './Components/Logout';
import Registration from './Pages/Registration';
import Feedback from './Pages/Feedback';
import Policy from './Pages/Policy';
import NotFound from './Pages/NotFound';

import Header from './Components/Header';
import RouteTitleUpdater from './Components/RouteTitleUpdater';

import PublicRoute from './Components/PublicRoute';
import PrivateRoute from './Components/PrivateRoute';
import SuperProtectedRoute from './Components/SuperProtectedRoute';

const App = () => {
  const location = useLocation();

  const showHeaderOnRoutes = ['/home', '/applications', '/case', '/favorites', '/appointments', '/complaints', '/other-cases', '/types-categories-phases', '/user-access', '/deactivated-accounts', '/view-feedback', '/emails-arbitration-managers', '/inbox', '/inbox-for-administration', '/regions', '/tstng'];
  
  const shouldShowHeader = showHeaderOnRoutes.includes(location.pathname) 

  return (
    <ModalProvider>
      <TimeModalProvider>
      <div className="App">
        {shouldShowHeader && <Header />}
        <Routes>
          <Route path="/" element={<PublicRoute><Index /></PublicRoute>} />
          <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/applications" element={<PrivateRoute><Applications /></PrivateRoute>} />
          <Route path="/case/:id" element={<PrivateRoute><PageOfCase /></PrivateRoute>} />
          <Route path="/favorites" element={<PrivateRoute><Favorites /></PrivateRoute>} />
          <Route path="/appointments" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор', 'Менеджер']}><Appointments /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/complaints" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор', 'Менеджер']}><Complaints /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/other-cases" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор', 'Менеджер']}><OtherCases /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/view-feedback" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор']}><ViewFeedback /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/types-categories-phases" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор']}><TypesCategoriesPhases /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/user-access" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор']}><UserAccess /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/deactivated-accounts" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор']}><DeactivatedAccounts /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/emails-arbitration-managers" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор']}><EmailsAM /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/inbox" element={<PrivateRoute><Inbox /></PrivateRoute>} />
          <Route path="/tstng" element={<PrivateRoute><SuperProtectedRoute allowedRoles={['Администратор']}><Testing /></SuperProtectedRoute></PrivateRoute>} />
          <Route path="/safety/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          <Route path="/auth/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/auth/registration" element={<PublicRoute><Registration /></PublicRoute>} />
          <Route path="/auth/logout" element={<Logout />} />
          <Route path="/feedback" element={<PublicRoute><Feedback /></PublicRoute>} />
          <Route path="/privacy-policy" element={<Policy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <RouteTitleUpdater/>
      </TimeModalProvider>
    </ModalProvider>
  );
};

export default App;
